export default "__VITE_ASSET__BR$4K_A3__"